import { Box, Chip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface TagWithDetailsProps {
  knowledgeLevel?: string
  pageType?: string
  timeSpan?: number
}

interface PageTypeProps {
  textKey: 'article' | 'guide' | 'faq' | 'news'
  textColor: string
  backgroundColor: string
}

const pageTypeMap: Record<string, PageTypeProps> = {
  ArticlePage: {
    textKey: 'article',
    textColor: 'error.dark',
    backgroundColor: 'surface.orange',
  },
  GuidePage: {
    textKey: 'guide',
    textColor: 'info.dark',
    backgroundColor: 'surface.blue',
  },
  FaqPage: {
    textKey: 'faq',
    textColor: 'primary.dark',
    backgroundColor: 'surface.purple',
  },
  NewsPage: {
    textKey: 'news',
    textColor: 'secondary.dark',
    backgroundColor: 'surface.green',
  },
}

const PageTypeChip = ({ pageType }: { pageType?: string }) => {
  const { t } = useTranslation()

  if (!pageType || !pageTypeMap[pageType]) {
    return null
  }

  const { textKey, textColor, backgroundColor } = pageTypeMap[pageType]

  return (
    <Chip
      label={t(`translation:common.pageType.${textKey}`)}
      sx={{
        backgroundColor,
        color: textColor,
        border: 'none',
      }}
    />
  )
}

const TagWithDetails = ({
  knowledgeLevel,
  pageType,
  timeSpan,
}: TagWithDetailsProps) => {
  const timeSpanString = timeSpan + ' minuter'
  const readingDetails = () => {
    if (knowledgeLevel && timeSpan) {
      return knowledgeLevel + ' • ' + timeSpanString
    }
    if (knowledgeLevel) {
      return knowledgeLevel
    }
    if (timeSpan) {
      return timeSpanString
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={2} pt={1.5}>
      <PageTypeChip pageType={pageType} />
      {readingDetails() && (
        <Typography variant="caption">{readingDetails()}</Typography>
      )}
    </Box>
  )
}

export default TagWithDetails
